module.exports = __webpack_public_path__ + "img/histogram-dark.6bd0b166.svg";